import { makeAutoObservable } from 'mobx'
import config from '@/config'
import axios from 'axios'
import User from './User'
import api from './api'
import tools, { isOnlineByHostname, sentryLog } from './tools'
import CallApp from './CallApp'
import Router from './Router'
import sensors from './sensorsdata.es6.min.js'
import environment from './environment.js'
import { getPageTitleByPathName } from '@/constants/buryingpoint'
import { getBuryPoints } from '@/utils/buryPoints'
import { removeProtocol } from '@/utils'

import { toast } from 'react-hot-toast'

import {NO_CDN_BASE_URL,BASE_URL,CDN_BASE_URL}  from  './base_url'

/**
 * @class Store
 * @description 全局系统级store（提供公共的系统/全局级操作），包含一些公共次级store：user，api
 * @extends {AutoObservable}
 * @property {User} user - User object
 */

class System {
    static user
    static axios
    static CDN_AXIOS
    static NO_CDN_AXIOS
    static node_zhuma_axios
    static node_zhongheschool_axios
    static crm_zhongheschool_axios
    static mock_axios
    static api
    static tools
    // 基础配置信息
    static config
    static callApp
    static router
    static sensors
    static sensorsLog
    static environment
    static axiosNoWithCredentials
    static bussinessName
    storage = {}

    constructor() {
        makeAutoObservable(this)
        this.api = api
        this.config = config
        this.tools = tools
        this.environment = environment

        this.isMultiTerminalLogin = true // 是否多端登录

        this.addMFun()
        // axios实例化通用配置
        const axios_base = {
            baseURL: '',
            headers: {
                channel:
                    window.location.href.indexOf('zhuma') != -1
                        ? 'zhumaWeb'
                        : 'schoolWeb',
                clientType: 'web',
                appName:
                    window.location.href.indexOf('zhuma') != -1
                        ? 'zhuma'
                        : 'school'
            }
        }

      // 模考专用“get”请求
      // note:以后不要改动，也不要用，全部用CDNAxios
      this.mock_axios = axios.create(
        Object.assign(JSON.parse(JSON.stringify(axios_base)), {
          // 本地环境访问全称的域名  非本地使用相对路径访问接口
          baseURL: CDN_BASE_URL,
          withCredentials:false
        })
      )

      this.NO_CDN_AXIOS = axios.create(
        Object.assign(JSON.parse(JSON.stringify(axios_base)), {
          // 本地环境访问全称的域名  非本地使用相对路径访问接口
          baseURL:NO_CDN_BASE_URL ,
        })
      )

      this.CDN_AXIOS = axios.create(
        Object.assign(JSON.parse(JSON.stringify(axios_base)), {
          baseURL:CDN_BASE_URL
        })
      )


        this.axiosNoWithCredentials = axios.create(
            Object.assign(JSON.parse(JSON.stringify(axios_base)), {
                // 本地环境访问全称的域名  非本地使用相对路径访问接口
                baseURL: BASE_URL,
            })
        )

        // java新接口的实例
        this.axios = axios.create(
            Object.assign(axios_base, {
                // 本地环境访问全称的域名  非本地使用相对路径访问接口
                baseURL: BASE_URL,
                withCredentials:true,
            })
        )

        // node竹马老接口的实例
        this.node_zhuma_axios = axios.create(
            Object.assign(axios_base, {
                baseURL: BASE_URL
            })
        )
        // node众合老接口的实例
        this.node_zhongheschool_axios = axios.create(
            Object.assign(axios_base, {
                baseURL: BASE_URL
            })
        )

        // 调用crm的接口
        this.crm_zhongheschool_axios = axios.create(
            Object.assign(axios_base, {
                baseURL: BASE_URL,
                headers: {
                    channel: 'zhumaApp', // 写死 channel
                    appName:
                      window.location.href.indexOf('zhuma') != -1
                        ? 'zhuma'
                        : 'school'
                }
            })
        )


        this.initInterceptors()

        // 先初始神策，在调用new User(this)，要在User中使用神策埋点
        this.initSensors()

        this.user = new User(this)
        this.callApp = new CallApp(this)
        this.router = new Router(this)
    }

    setStorage(key, value) {
        this.storage[key] = value
    }

    getStorage(key) {
        return this.storage[key]
    }

    // 判断域名需不需要加m
    addMFun() {
        if (this.isZhumavip()) {
            return
        }
        const pathName = window.location.pathname
        const searchs = window.location.search
        const proToCol = `${window.location.protocol  }//`
        const hostOnes = window.location.host.split('.')
        const hostOne = hostOnes[0]
        let resultHost = ''
        if (hostOne == 'um') {
            hostOnes[0] = 'uat'
        } else if (hostOne == 'm') {
            hostOnes[0] = 'www'
        } else if (hostOne == 'tm') {
            hostOnes[0] = 'test'
        } else {
            return
        }
        resultHost = hostOnes.join('.')

        window.location.href = proToCol + resultHost + pathName + searchs
    }

    // 获取当前环境
    getHost() {
        return process.env.PC_ENV
    }

    // 初始化
    init() {
        if (typeof window !== 'undefined') {
            this.setHtmlFontSize()
            // 监听页面尺寸变化
            window.onresize = () => this.setHtmlFontSize()
        }
    }

    // 获取公共属性‘当前所处刷题业务类型’,通过缓存(优先)或者路由
    getExerciseType = () => {
        if (this.isZhumavip()) {
            if (this.getItem('exerciseTypeMark') == '104') {
                return '法律职业资格考试'
            } else if (this.getItem('exerciseTypeMark') == '90') {
                return '法律硕士联考'
            }else if (this.isFakao()) {
                return '法律职业资格考试'
            } else if (!this.isFakao()) {
                return '法律硕士联考'
            } else {
                // 给个默认值吧
                return '法律职业资格考试'
            }
        }else { //众合
            return null
        }
    }

    // 获取刷题设置业务类型
    getExaminationType = () => {
        if (this.isZhumavip()) {
            if (this.getItem('exerciseTypeMark') == '104') {
                return '法考'
            } else if (this.getItem('exerciseTypeMark') == '90') {
                return '法硕'
            }
        } else {
            return null
        }
    }
    // 获取公共属性‘商城业务类型’ 众合 和 竹马 判断方法不一样
    getBusinessType = () => {
        if (this.isZhumavip()) {
            if (this.getItem('exerciseTypeMark') == '104') {
                return '法考'
            } else if (this.getItem('exerciseTypeMark') == '90') {
                return '法硕'
            }
        } else {
            if (this.isFakao()) {
                return '法考'
            } else {
                return '法硕'
            }
        }
    }

    getItem(key) {
        const storeData = window.localStorage.getItem(key);
        if (!storeData) {
            return null;
        }
        const parsedData = JSON.parse(storeData);

        if (key == 'exerciseTypeMark') {
            return parsedData.value
        }
        const currentTimestamp = new Date().getTime();

        if (currentTimestamp - parsedData.timestamp <= parsedData.expire) {
            return parsedData.value
        } else {
            window.localStorage.removeItem(key);
        }
        return null;
    }

    setItem(key, value, expire = 2000) {
        const obj = {
            value,
            expire,
            timestamp: new Date().getTime()
        }
        const stringfiedData = JSON.stringify(obj);
        window.localStorage.setItem(key, stringfiedData);
    }

    async get(url, params) {
        return await this.axios.get(url,  {
            params,
            headers: {
                token: localStorage.getItem('react_user_info') ? JSON.parse(localStorage.getItem('react_user_info')).token : '',
                mtoken: localStorage.getItem('react_user_info') ? JSON.parse(localStorage.getItem('react_user_info')).token : '',
                stoken: localStorage.getItem('react_user_info') ? JSON.parse(localStorage.getItem('react_user_info')).token : ''
            }
        })
    }

    // 初始化神策
    async initSensors() {
        const xiangmu =
            window.location.host.split('.')[0] === 'www' ||
            window.location.host.split('.')[0] === 'm' ||
            'zhumavipzhongheschool'.indexOf(
                window.location.host.split('.')[0]
            ) !== -1
                ? 'production'
                : 'default'
        // 需要埋页面驻留的页面 ： 首页、专项练习数据报告、每日任务详情、练习报告、全部解析详情、错题解析详情、做题详情、打卡详情（众合app）、众合名师列表
        const NEW_SEND_MAP = ['/', '/fakao/', '/fakao', '/fashuo/','/fashuo', '/','/w/dataReport','/obt/analysis','/w/answerAnalysis','/w/reciteBrushQuestions','/w/myWrongQuestion','/w/exerciseFashuo','/w/sujiQuestion','/w/mokao/intelligentTopic','/obt','/fakao/teacher', '/fashuo/teacher']
        // 神策官网 SDK 集成 (Web) https://manual.sensorsdata.cn/sa/latest/sdk-web-7545024.html
        sensors.init({
            server_url: `https://bi.zhongheschool.com/sa.gif?project=${xiangmu}`,
            // is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
            //  有些页面需要根据参数，所以关闭单页面自动发pv，全部通过自定义history发送
            use_client_time: true,
            send_type: 'beacon',
            show_log: !isOnlineByHostname(), // 控制台显示数据开关
            scrollmap: {
                //collect_url	返回真会采集当前页面的数据，返回假表示不采集当前页面,设置这个函数后，内容为空的话，是返回假的。不设置函数默认是采集所有页面。
                collect_url: function() {
                    if (NEW_SEND_MAP?.includes(window.location.pathname)) {
                        return true
                    }
                }
            },
            heatmap: {
                // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
                clickmap: 'default',
                // 是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
                scroll_notice_map:'default',
                // 设置触达图的有效停留时间，默认超过 4 秒以上算有效停留。
                scroll_delay_time: 4000,
                scroll_event_duration: 18000 //单位秒，预置属性停留时长 event_duration 的最大值。默认5个小时，也就是300分钟，18000秒。
            }
        })
        sensors.registerPage({
            currentLoginPlatform: `${this.isZhumavip() ? '竹马' : '众合'}PC`,
            businessType: this.getBusinessType,
            examinationType: this.getExaminationType,
            currentExaminationTypeUser: this.getExerciseType,
        })
        // TODO:902 触发停留事件
        sensors.registerPropertyPlugin({
            isMatchedWithFilter:function(data){
                return data.event === "$WebStay";
            },
            properties:function(data){
                const {
                    primaryCatagory,
                    fakaoQuestionType,
                    totalNumber,
                    masteryDegree,
                    numberCompletedQuestions,
                    practiseFunction,
                    secondaryDirectory,
                    secondaryCatagory,
                    firstDirectory
                } = getBuryPoints()
                data.properties={
                    ...data.properties,
                    appPageTitle:getPageTitleByPathName() || undefined,
                    primaryCatagory:!!primaryCatagory  &&  primaryCatagory || undefined,
                    firstDirectory:!!firstDirectory  &&  firstDirectory || undefined,
                    secondaryCatagory:!!secondaryCatagory  &&  secondaryCatagory || undefined,
                    secondaryDirectory:!!secondaryDirectory  &&  secondaryDirectory  || undefined,
                    practiseFunction:!!practiseFunction  &&  practiseFunction || undefined,
                    fakaoQuestionType:!!fakaoQuestionType  &&  fakaoQuestionType || undefined,
                    numberCompletedQuestions:!!numberCompletedQuestions  &&  numberCompletedQuestions || undefined,
                    masteryDegree:!!masteryDegree  &&  masteryDegree || undefined,
                    totalNumber:!!totalNumber  &&  totalNumber || undefined,
                }
            }
        });
        this.sensors = sensors
    }

    getFrom(key) {
        if (!key) return key
        const from = {
            // 活动入口
            fudai: '福袋',
            zhongbuguanggaowei: '中部广告位',
            kaiping: '开屏',
            tanchuang: '弹窗',
            weibo: '微博',
            shangchengtuijian: '商城推荐',
            fasuopromotion: '法硕促销活动',
            tushuguanggaowei: '图书广告位',
            '510fakao': '510促销法考会场',
            '510fashuo': '510促销法硕会场',
            shangzhumasouzhanma: '上竹马搜战吗活动',
            huodongyemianfenxiang: '活动页面分享',
            zhumatikusousuo: '竹马题库搜索',
            pcsaoma: 'PC扫码',
            '5mokaotuiguang': '5月模考推广',
            enterExamRoomPop: 'H5进入考场提示弹窗',
            viewAnswers: 'H5查看答案提示弹窗',
            shuangshiyizhu: '双十一活动主会场',
            shuangshiyifakao: '双十一法考会场',
            shuangshiyi23fashuo: '双十一2023法硕会场',
            shuangshiyi24fashuo: '双十一2024法硕会场',
            shuangshiyijika: '双十一集卡会场',
            jikaliulanhuodongyerenwu: '集卡浏览活动页任务',
            jikafenxiangrenwu: '集卡分享任务',
            huodongshouyetanchuang: '活动首页弹窗',
            jikayaoqingrenwu: '集卡邀请任务',
            shuangshierzhuTop: '双十二活动主会场顶部入口',
            shuangshierzhuBottom: '双十二活动主会场底部入口',
            shuangshierfakao: '双十二法考会场',
            shuangshierfashuo: '双十二法硕会场',
            nianhuojiezhu: '年货节主会场',
            nianhuojiefakao: '年货节法考会场',
            nianhuojiefashuo: '年货节法硕会场',
            nianhuojienianbaohome: '年货节年报首页',
            nianhuojienianbaojiangpin: '年货节年报奖品',
            nopctopsaoma: '顶部PC扫码',
            nopcyuanwangsaoma: '新年愿望PC扫码',
            nopcdatisaoma: '答题抽奖PC扫码',
            shangpinxiangqingyeguanggaowei: '详情页广告',
            "618fakao": "2023年618法考会场",
            "618fashuo": "2023年618法硕会场",
            youxiyemianfanhui: "游戏页面返回",
            huodongrenwutanchuang: "活动任务弹窗去下单",
            mokaohuodong: "模考活动页面",
            tiaozhanjilutanchuang: "挑战记录弹窗去使用",
            tiaozhanchenggongtanchuang: "挑战成功弹窗去使用",
            "618fakaotanchuang": "2023年618法考会场弹窗",
            "618fashuotanchuang": "2023年618法硕会场弹窗",
            huodongrenwufenxiang: "活动任务去分享",
            '2024xinrenhuodong': '2024新人活动',
            // 以后不要再用了，直接传中文 2023/01/09
            // 还得用，要不然crm配置的中文会出问题 2023/01/10
        }

        if (key in from) {
            return from[key]
        }
        return key
    }

    /**
     * 神策埋点 & 打印埋点日志 (所有的埋点都进行日志打印)
     * @param {*} key 事件名称 例如: browseEventVenue(活动会场预览)
     * @param {*} params 事件埋点参数
     */
    sensorsLog = (key, params) => {
        // 自动计算来源信息
        if ('activityEntrance' in params) {
            params.activityEntrance = this.getFrom(params.activityEntrance)
        }

        config.DEBUG && console.log(key, params)
        sensors.track(key, params)
    }

    // 初始化拦截器
    initInterceptors() {
        // 处理成功返回的内容
        const sucessData = (data) => {
            return {
                status: 200,
                data
            }
        }
        // 处理失败返回的内容
        const errorData = (status, error, data) => {
            return {
                status,
                error,
                data
            }
        }

        const res = (response) => {
          sentryLog(response)
            // 2xx 范围内的状态码都会触发该函数。
            if (response.status != 200) {
                return errorData(
                    response.status,
                    '服务器处理了请求，但出了某些问题',
                    response.data
                )
            }

            // 如果返回内容里有data且不为空
            if (response.data) {
                // 如果没有返回code 就直接把data返回
                if (
                    typeof response?.data === 'object' &&
                    !('code' in response?.data)
                ) {
                    return sucessData(response.data)
                }

                // 30007 表示认证失败 回到首页
                if (response.data.code == 30007) {
                  const href = removeProtocol()
                    // 清除用户状态
                    this.user.injectUserInfo(null)
                    console.warn('用户认证失败', response)
                    if (this.isZhumavip()){
                      return (window.location.href = `${
                        window.location.origin
                      }/w/qrlogin?from=${encodeURIComponent(
                        encodeURI(href)
                      )}`)
                    }
                    // encodeURIComponent & encodeURI 解决参数丢失问题
                    else{
                      return (window.location.href = `${
                        window.location.origin
                      }/ang/login?from=${encodeURIComponent(
                        encodeURI(href)
                      )}`)
                    }
                    // return errorData(401, '用户认证失败，请重新登录')
                }

                // 30008  表示用户在其他端登录 回到首页，支持用户游客身份使用部分功能
                if (response.data.code == 30008) {
                    const href = removeProtocol()
                    // 清除用户状态
                    this.user.injectUserInfo(null)

                    //  this.isMultiTerminalLogin 避免多次弹toast
                    this.isMultiTerminalLogin && toast.error('您的账号已在其他浏览器登录，如需要请重新登录')
                    this.isMultiTerminalLogin = false

                    // 竹马回登录页 众合回首页
                    setTimeout(() => {
                    if (this.isZhumavip()){
                        return (window.location.href = `${
                          window.location.origin
                        }/w/qrlogin?from=${encodeURIComponent(
                          encodeURI(href)
                        )}`)
                      } else{
                        return (window.location.href = window.location.origin)
                      }
                    }, 3000)
                }

                // code是000000是老代码的判断 200是恩斌java的判断 0是亚进java的判断
                if (
                    response.data.code == 200 ||
                    response.data.code == 0 ||
                    response.data.code == '000000'
                ) {
                    if (this.isEmpty(response.data.data)) {
                        console.warn('请求响应没有data.data')
                        return sucessData(response.data)
                    }
                    return sucessData(response.data.data)
                } else {
                    return errorData(response.data.code, response.data.msg)
                }
            } else {
                console.error('请求响应没有data')
                return errorData(200, '请求响应为空[data undefined]')
            }
        }

        const err = (error) => {
          sentryLog(error.response)
          try {
            // TODO:网络中断不关心
            if (['ECONNABORTED', 'ERR_NETWORK'].includes(error.code)) {
              return
            }
            if (['503','502'].some((item) => error.message.includes(item))) {
              return
            }
            // data params
            const payload = error.config.data || error.config.params
            sendError({
              level: 'error',
              message: `【 PC 】${error.config.url || ''} payload: ${JSON.stringify(payload)}  X error:${error.message}` || '',
              stack: error.code || '',
              error: `【 PC 】 ${error.config.url || ''}  payload: ${JSON.stringify(payload)}  X error: ${error.message}` || ''
            })
          } catch (e) {

          }
            console.error(error)
            // 超出 2xx 范围的状态码都会触发该函数。
            // 对响应错误做点什么
            return Promise.resolve(errorData(500, '服务器错误', error))
        }

        // 添加响应拦截器
        this.axios.interceptors.response.use(res, err)

        // 添加响应拦截器
        this.node_zhuma_axios.interceptors.response.use(res, err)

        // 添加响应拦截器
        this.node_zhongheschool_axios.interceptors.response.use(res, err)

        this.mock_axios.interceptors.response.use(res, err)

        this.NO_CDN_AXIOS.interceptors.response.use(res, err)

        this.CDN_AXIOS.interceptors.response.use(res, err)

        this.CDN_AXIOS.interceptors.request.use(config => {
          if (config.method.toLocaleLowerCase() === 'get') {
            config.params = {
              ...config.params,
            }
          }
          delete config.headers.token
          delete config.headers.mtoken
          delete config.headers.stoken
          return config
        }, error => {
          return Promise.reject(error)
        })


        this.mock_axios.interceptors.request.use(config => {
            if (config.method.toLocaleLowerCase() === 'get') {
                config.params = {
                    ...config.params,
                }
            }
            delete config.headers.token
            delete config.headers.mtoken
            delete config.headers.stoken
            return config
        }, error => {
            return Promise.reject(error)
        })
    }

    // 判断响应
    isEmpty(data) {
        if (typeof data === 'undefined') {
            return true
        }

        if (typeof data === 'null') {
            return true
        }

        if (typeof data === '') {
            return true
        }

        return false
    }

    // 判断是否是ipad
    isMac() {
        const ua = navigator.userAgent.toLowerCase()
        return /Mac/gi.test(ua)
    }

    // 由于iPad安全策略无法，在接口回调中无法打开新窗口（window.open）,所以加该方法
    openUrl = (url) => {
        if (this.isMac()) {
            window.location.href = url
        } else {
            window.open(url)
        }
    }

    // 需要判断是否登录的方法，需要登录直接跳转登录，不需要登录调用callback
    loginHref = (callback) => {
        if (this.user.is_login) {
            callback()
        } else {
            window.location.href = this.isZhumavip()
                ? `/w/qrlogin?from=${encodeURIComponent(
                    encodeURI(location.href)
                )}`
                : `/${this.businessType()}/login?from=${encodeURIComponent(
                    encodeURI(location.href)
                )}`
        }
    }

    // 判断当前域名是否是竹马
    isZhumavip() {
        return window.location.host.indexOf('zhuma') !== -1
    }

    // 判断域名 是否是法考
    isFakao() {
        return window.location.pathname.startsWith('/fakao')
    }

    // 判断域名 判断业务类型
    businessType() {
        return window.location.pathname.startsWith('/fakao')
            ? 'fakao'
            : 'fashuo'
    }

    // 获取cookie
    getCookie = (key) => {
        const name = `${key  }=`
        const ca = document.cookie.split(';')
        for (let i = 0; i < ca.length; i++) {
            const c = ca[i].trim()
            if (c.indexOf(name) === 0) {
                // 处理 node 加密 token 问题
                if (key == 'token' || key == 'stoken' || key == 'mtoken') {
                    return this.getNodeJsCookie(
                        c.substring(name.length, c.length)
                    )
                } else {
                    return c.substring(name.length, c.length)
                }
            }
        }

        return null
    }

    // 获取node加密token解析
    getNodeJsCookie(value) {
        let nodejsToken = decodeURIComponent(value)
        if (nodejsToken.indexOf('.') === -1) return nodejsToken
        const strings = nodejsToken.split('.')
        nodejsToken = strings[0]
        const newString = nodejsToken.split(':')
        return newString[1]
    }

    // 删除cookie
    delCookie(key) {
        const exp = new Date()
        exp.setTime(exp.getTime() - 1)
        const cval = this.getCookie(key)
        if (cval != null) {
            document.cookie =
                `${key  }=${  cval  };path=/;expires=${  exp.toGMTString()}`
        }
    }

    // 设置cookie
    setCookie(key, value) {
        const date = new Date()
        date.setTime(date.getTime() + 90 * 24 * 60 * 60 * 1000)
        document.cookie =
            `${key  }=${  value  };path=/;expires=${  date.toGMTString()}`
    }

    // 设置html的font-size，通过rem维持整体的自适应
    setHtmlFontSize() {
        const width =
            document.documentElement.clientWidth ||
            document.body.clientWidth ||
            window.innerWidth
        document.documentElement.style.fontSize = `${width / 7.5}px`
    }
}

export default new System()
